var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 48,
    viewBox: "0 0 53 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 11.5002L26.2111 5.92246C25.4085 4.31718 25.0072 3.51449 24.4084 2.92808C23.8789 2.40949 23.2408 2.0151 22.5402 1.77344C21.7479 1.50017 20.8505 1.50017 19.0557 1.50017H9.5C6.69974 1.50017 5.29961 1.50017 4.23005 2.04514C3.28924 2.5245 2.52433 3.2894 2.04497 4.23022C1.5 5.29977 1.5 6.69991 1.5 9.50017V11.5002M1.5 11.5002H39.5C43.7004 11.5002 45.8006 11.5002 47.4049 12.3176C48.8161 13.0367 49.9635 14.184 50.6825 15.5952C51.5 17.1996 51.5 19.2998 51.5 23.5002V34.5002C51.5 38.7006 51.5 40.8008 50.6825 42.4051C49.9635 43.8163 48.8161 44.9637 47.4049 45.6827C45.8006 46.5002 43.7004 46.5002 39.5 46.5002H13.5C9.29961 46.5002 7.19941 46.5002 5.59507 45.6827C4.18386 44.9637 3.0365 43.8163 2.31745 42.4051C1.5 40.8008 1.5 38.7006 1.5 34.5002V11.5002ZM26.5 37.7502C26.5 37.7502 34 34.1754 34 28.8132V22.5574L28.531 20.6032C27.217 20.1325 25.78 20.1325 24.466 20.6032L19 22.5574V28.8132C19 34.1754 26.5 37.7502 26.5 37.7502Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStamp);
export default __webpack_public_path__ + "static/media/stamp.78ee92c7798c5aac37b973749e168ff4.svg";
export { ForwardRef as ReactComponent };